export default __webpack_public_path__ + "static/media/value_04.ecc3af20.png";